/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React,{ useState } from "react"

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import clip from '05Images/clip.svg'

/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { CFFileUpload } from "03CommonApiParts/CommonFunction";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------ ファイル ------*/
const SsvgIcon = styled.svg`//SVG用
width:${assets().size.svgWidth};
height:${assets().size.svgHeight};
padding:5px 10px;
`;
const SlabelFakeButton = styled.label`//ファイル選択ボタン
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${assets().color.blue};
    cursor: pointer;
    &:active{
        color:${assets().color.border};
    }
`;
//使い方
//<FileUpload 
//fileInput={fileInput}
//setFileInput={setFileInput}/>

/* ========================== */  
/* ========== Main ========== */  
/* ========================== */  

export const FileUpload = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */    
    const { fileInput, setFileInput} = props;
    /* ========================== */  
    /* ========== state ========== */  
    /* ========================== */ 
    const [snackbarMessage, setSnackbarMessage] = useState({//スナックバー表示用
        open:false
    });
    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    /*------ ファイル選択ボタンを押した時の処理　------*/
    const handleFileSelect = (event) => {
        const files = event.target.files;//ファイルを取得
        
        /* ファイルアップロード処理 */
        CFFileUpload(files,fileInput,setFileInput, (result)=>{
            document.getElementById('fileInput').value = '';//inputの中身を空にする
            if(result.isSuccessed){//APIリクエスト結果 = 正常


            }else{//APIリクエスト結果 = 異常
                /* エラーメッセージを表示 */
                setSnackbarMessage({//スナックバー表示   
                    ...snackbarMessage,
                    open:true,
                    message:result.message,//APIによるエラー
                    type: 2,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            };
        });
    };
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return (
        <>
            {/* ボタン */}
            <SlabelFakeButton >
                <SsvgIcon className='svgStyle'>
                    <use xlinkHref={`${clip}#clip`}></use>
                </SsvgIcon>
                <input
                hidden 
                multiple
                type="file" 
                id="fileInput" 
                onChange={handleFileSelect}
                />
        </SlabelFakeButton>
        {/* スナックバー */}
        <SnackBar
        content={snackbarMessage}
        set={setSnackbarMessage}/>

    </>
    );
};




